import axios from "axios"

const API_URL = "https://dashboard.erhanreklam.com/api/"
//const API_URL = "https://37.77.26.9/api/"
export const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})

export const axiosPrivateInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})
